module.exports = __webpack_public_path__ + "img/page_title_06.f2dff9cf.png";